'use strict';

var Utils = require('../utils/utils');
var Navs = require('./lib/navs');
var Features = require('./lib/features');
var Visibility = require('./lib/visibility');

// Constructor
var Megamenu = function() {
  var self = this;

  self.config = {
    // Main nav
    'navAlphaLevelItem'        :  '.main-nav > ul > li',
    'navAlphaLevelLink'        :  '.main-nav > ul > li > a',
    'navBetaLevel'             :  '.main-nav > ul > li > ul',

    // Megamenu
    'megamenu'                 :  '.megamenu',
    'megamenuItem'             :  '.megamenu__item',
    'megamenuItemGrid'         :  '.megamenu__item-grid',
    'megamenuItemTemplate'     :  '<div class="megamenu__item" data-menu-item-slug="<%= content.slug %>"></div>',
    'megamenuFeature'          :  '.megamenu__feature',
    'megamenuFeatureContent'   :  '.megamenu__feature-content',
    'megamenuFeatureTemplate'  :  '.megamenu__feature-template',

    // Main header
    'mainHeader'               :  '.main-header'
  }

  self.createContainer = function() {
    var $megamenu = $(self.config.megamenu);

    if (!$megamenu.length) {
      $(self.config.mainHeader).append('<div class="megamenu"></div>');
    }
  }

  self.init = function() {
    var largeViewports = function() {
      self.createContainer();

      new Navs({
        item: self.config.navAlphaLevelItem,
        children: self.config.navBetaLevel,
        megamenu: self.config.megamenu,
        megamenuItem: self.config.megamenuItem,
        containerTemplate: self.config.megamenuItemTemplate
      }).init();

      new Features({
        content: self.config.megamenuFeatureContent,
        template: self.config.megamenuFeatureTemplate,
        container: self.config.megamenuItem,
        feature: self.config.megamenuFeature
      }).init();

      new Visibility({
        item: self.config.navAlphaLevelItem,
        link: self.config.navAlphaLevelLink,
        megamenuItem: self.config.megamenuItem,
        megamenuItemGrid: self.config.megamenuItemGrid,
        mainHeader: self.config.mainHeader
      }).init();
    };

    var smallViewports = function() {
      new Visibility({
        item: self.config.navAlphaLevelItem,
        link: self.config.navAlphaLevelLink,
        megamenuItem: self.config.megamenuItem,
        megamenuItemGrid: self.config.megamenuItemGrid,
        mainHeader: self.config.mainHeader
      }).destroy();
    };

    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
  }
};

module.exports = Megamenu;
